import httpClient from '@/api_module/http-client'
import { isEmpty } from 'lodash'

export default {
  // Set tokens
  SET_TOKENS(state, { access, refresh }) {
    state.accessToken = access
    state.refreshToken = refresh
  },
  /**
   * Update account profile data
   * @param {*} state
   * @param {*} profile
   */
  setProfile(state, profile = {}) {
    if (!isEmpty(profile)) {
      state.profile = Object.assign({}, state.profile, profile)
      // Set account ID.
      if (isEmpty(state.accountId))
        state.accountId = profile.uuid ? profile.uuid : null
    } else {
      state.profile = state.defaultProfile

      state.accountId = null
    }
  },
  /**
   * Set Authorization tokens
   * @param state
   * @param tokens
   */
  setAuthTokens(state, tokens = {}) {
    state.auth_tokens = tokens
    if (state.auth_tokens.access_token) {
      httpClient.headers = {
        Authorization: 'Bearer ' + state.auth_tokens.access_token
      }
    }
  },

  setRefreshingState(state, value) {
    state.isTokenRefreshing = value
  },

  setRefreshingCall(state, value) {
    state.refreshingCall = value
  },

  setRouteStatus(state, status = '') {
    state.routeStatus = status
  }
}



// WEBPACK FOOTER //
// ./src/store/app/mutations.js